import React from 'react';

import { InboxFilterContext } from 'src/providers/InboxFilterProvider';

export const useInboxFilter = () => {
  return React.use(InboxFilterContext);
};
